import React from 'react';
import './BTeachers.css'; // <-- 🩹 CIRUGÍA: Importamos el CSS modular

// Recibimos la prop 'id' para que el scroll-to-section funcione.
function BTeachers({ id }) {
  return (
    // 🩹 CIRUGÍA: Clase "teachers-section" renombrada a "b-teachers-section"
    <section className="b-teachers-section" id={id || 'teachers'}>
      <div className="container">
        <h2 className="section-title">
          Profesores <span className="highlight-blue">especializados</span> en negocios
        </h2>
        <p className="section-subtitle">Certificados por Cambridge con experiencia real en el mundo corporativo</p>
        
        <div className="teachers-grid">
          <div className="teacher-card">
            <div className="teacher-avatar">💼</div>
            <div className="teacher-badge">CAMBRIDGE CERTIFIED</div>
            <h3 className="teacher-name">Business English</h3>
            <p className="teacher-title">Inglés Corporativo General</p>
            <ul className="teacher-specialties">
              <li>Negociaciones y presentaciones</li>
              <li>Emails y comunicación escrita</li>
              <li>Reuniones y videoconferencias</li>
              <li>Networking profesional</li>
              <li>Vocabulario corporativo avanzado</li>
            </ul>
          </div>

          <div className="teacher-card">
            <div className="teacher-avatar">📊</div>
            <div className="teacher-badge">ESPECIALISTA</div>
            <h3 className="teacher-name">Sales & Marketing</h3>
            <p className="teacher-title">Ventas y Marketing Internacional</p>
            <ul className="teacher-specialties">
              <li>Pitch de ventas en inglés</li>
              <li>Manejo de objeciones</li>
              <li>Marketing digital y contenido</li>
              <li>Presentaciones comerciales</li>
              <li>Cierre de deals internacionales</li>
            </ul>
          </div>

          <div className="teacher-card">
            <div className="teacher-avatar">💻</div>
            <div className="teacher-badge">TECH EXPERT</div>
            <h3 className="teacher-name">Tech & IT</h3>
            <p className="teacher-title">Tecnología y Desarrollo</p>
            <ul className="teacher-specialties">
              <li>Vocabulario técnico de software</li>
              <li>Metodologías ágiles en inglés</li>
              <li>Documentación técnica</li>
              <li>Code reviews y pair programming</li>
              <li>Presentaciones de arquitectura</li>
            </ul>
          </div>

          <div className="teacher-card">
            <div className="teacher-avatar">🎧</div>
            <div className="teacher-badge">CUSTOMER FOCUSED</div>
            <h3 className="teacher-name">Customer Service</h3>
            <p className="teacher-title">Atención al Cliente</p>
            <ul className="teacher-specialties">
              <li>Manejo de clientes difíciles</li>
              <li>Resolución de conflictos</li>
              <li>Empatía y comunicación efectiva</li>
              <li>Soporte técnico en inglés</li>
              <li>Scripts de servicio al cliente</li>
            </ul>
          </div>

          <div className="teacher-card">
            <div className="teacher-avatar">💼</div>
            <div className="teacher-badge">EXECUTIVE LEVEL</div>
            <h3 className="teacher-name">Executive Leadership</h3>
            <p className="teacher-title">Liderazgo Ejecutivo</p>
            <ul className="teacher-specialties">
              <li>Comunicación de alto nivel</li>
              <li>Presentaciones ante inversores</li>
              <li>Estrategia y toma de decisiones</li>
              <li>Manejo de crisis en inglés</li>
              <li>Networking ejecutivo internacional</li>
            </ul>
          </div>

          <div className="teacher-card">
            <div className="teacher-avatar">💰</div>
            <div className="teacher-badge">FINANCE SPECIALIST</div>
            <h3 className="teacher-name">Finance & Banking</h3>
            <p className="teacher-title">Finanzas y Banca</p>
            <ul className="teacher-specialties">
              <li>Terminología financiera avanzada</li>
              <li>Reportes y análisis financiero</li>
              <li>Negociaciones de inversión</li>
              <li>Presentaciones a stakeholders</li>
              <li>Compliance y regulación</li>
            </ul>
          </div>
        </div>

        {/* --- 🩹 CIRUGÍA: Inicio de la segunda sub-sección (Industrias) --- */}
        {/* Se elimina el 'style' en línea y se añade una clase */}
        <div className="b-teachers-subsection">
          <h2 className="section-title">
            El mercado <span className="highlight-blue">lo requiere</span>
          </h2>
          <p className="section-subtitle">Contenido especializado para cada industria</p>
          
          <div className="teachers-grid">
            <div className="teacher-card">
              <div className="teacher-avatar">🍽️</div>
              <div className="teacher-badge">HOSPITALITY</div>
              <h3 className="teacher-name">Restaurantes</h3>
              <p className="teacher-title">Gastronomía Internacional</p>
              <ul className="teacher-specialties">
                <li>Toma de órdenes en inglés</li>
                <li>Descripción de platillos y menú</li>
                <li>Manejo de alergias y restricciones</li>
                <li>Recomendaciones y upselling</li>
                <li>Atención a clientes internacionales</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🛒</div>
              <div className="teacher-badge">E-COMMERCE</div>
              <h3 className="teacher-name">Comercio Electrónico</h3>
              <p className="teacher-title">Ventas Online y Logística</p>
              <ul className="teacher-specialties">
                <li>Atención al cliente por chat/email</li>
                <li>Gestión de devoluciones</li>
                <li>Cross-border e-commerce</li>
                <li>Marketing digital internacional</li>
                <li>Negociación con proveedores</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🏨</div>
              <div className="teacher-badge">TOURISM</div>
              <h3 className="teacher-name">Hotelería</h3>
              <p className="teacher-title">Gestión Hotelera</p>
              <ul className="teacher-specialties">
                <li>Check-in y check-out</li>
                <li>Manejo de reservaciones</li>
                <li>Concierge y recomendaciones</li>
                <li>Resolución de quejas</li>
                <li>Servicios premium</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🚀</div>
              <div className="teacher-badge">STARTUPS</div>
              <h3 className="teacher-name">Emprendedores</h3>
              <p className="teacher-title">Startups y Nuevos Negocios</p>
              <ul className="teacher-specialties">
                <li>Pitch deck para inversionistas</li>
                <li>Networking en eventos internacionales</li>
                <li>Negociación con VCs y angels</li>
                <li>Presentación de productos innovadores</li>
                <li>Comunicación con equipos remotos</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">✈️</div>
              <div className="teacher-badge">TRAVEL & TOURS</div>
              <h3 className="teacher-name">Tours y Viajes</h3>
              <p className="teacher-title">Turismo y Experiencias</p>
              <ul className="teacher-specialties">
                <li>Guías turísticos en inglés</li>
                <li>Venta de paquetes y experiencias</li>
                <li>Historia y cultura local</li>
                <li>Coordinación de grupos internacionales</li>
                <li>Emergencias y primeros auxilios</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🏥</div>
              <div className="teacher-badge">HEALTHCARE</div>
              <h3 className="teacher-name">Salud y Bienestar</h3>
              <p className="teacher-title">Servicios Médicos y Wellness</p>
              <ul className="teacher-specialties">
                <li>Terminología médica básica</li>
                <li>Atención a pacientes extranjeros</li>
                <li>Explicación de tratamientos</li>
                <li>Turismo médico y dental</li>
                <li>Coordinación con seguros internacionales</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🏗️</div>
              <div className="teacher-badge">REAL ESTATE</div>
              <h3 className="teacher-name">Bienes Raíces</h3>
              <p className="teacher-title">Inmobiliaria y Propiedades</p>
              <ul className="teacher-specialties">
                <li>Descripción de propiedades</li>
                <li>Negociación de compra-venta</li>
                <li>Contratos y términos legales</li>
                <li>Tours virtuales y presenciales</li>
                <li>Atención a inversionistas extranjeros</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">🎓</div>
              <div className="teacher-badge">EDUCATION</div>
              <h3 className="teacher-name">Educación</h3>
              <p className="teacher-title">Instituciones y Capacitación</p>
              <ul className="teacher-specialties">
                <li>Admisiones internacionales</li>
                <li>Comunicación con padres extranjeros</li>
                <li>Presentación de programas académicos</li>
                <li>Intercambios y convenios</li>
                <li>Capacitación corporativa en inglés</li>
              </ul>
            </div>

            <div className="teacher-card">
              <div className="teacher-avatar">💪</div>
              <div className="teacher-badge">FITNESS</div>
              <h3 className="teacher-name">Fitness y Deportes</h3>
              <p className="teacher-title">Entrenamiento y Wellness</p>
              <ul className="teacher-specialties">
                <li>Instrucciones de ejercicios</li>
                <li>Planes de entrenamiento personalizados</li>
                <li>Nutrición y suplementación</li>
                <li>Motivación y coaching</li>
                <li>Atención a clientes internacionales</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BTeachers;
